// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-price-editor{display:grid;height:100%}.ag-price-editor input{min-width:0}`, "",{"version":3,"sources":["webpack://./src/agElements/editors/agPriceEditor.scss"],"names":[],"mappings":"AAAA,iBAAiB,YAAY,CAAC,WAAW,CAAC,uBAAuB,WAAW","sourcesContent":[".ag-price-editor{display:grid;height:100%}.ag-price-editor input{min-width:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
